import "./newsCard.css";
import { Link } from "react-router-dom";

// Helper function to generate URL-friendly slug
const slugify = (text) =>
  text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w\-]+/g, "") // Remove non-word characters
    .replace(/\-\-+/g, "-") // Replace multiple - with a single -
    .replace(/^-+/, "") // Trim - from start
    .replace(/-+$/, ""); // Trim - from end

const NewsCard = ({ img, type, title, date }) => {
  return (
    <Link to={`/news/${slugify(title)}`} className="blog-no-underline">
      <div
        className={`newscard-container ${
          img ? "news-card-with-image" : "news-card-no-image"
        }`}
      >
        {img && <img className="newscard-img" src={img} alt={title} />}
        <div className="newscard-info">
          <div className="newscard-text-group">
            <p className="newscard-type">{type}</p>
            <h2 className="newscard-title">{title}</h2>
          </div>
          <p className="newscard-date">{date}</p>
        </div>
      </div>
    </Link>
  );
};

export default NewsCard;
